import { SettingsParser } from "./settings-parser";
import { ViewSettings } from "../settings/view-settings";

export class ViewSettingsParser extends SettingsParser {
  constructor(canvasParser) {
    super();
    this.canvasParser = canvasParser;
    this.parsedFieldNames = ["canvas"];
  }

  static createSettings(settings, defaultSettings, canvasParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {};
    if (settings.canvas !== undefined && canvasParser !== undefined) {
      parsedSettings.canvas = canvasParser.parse(settings.canvas, defaultSettings?.canvas);
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ViewSettingsParser.createSettings(settings, defaultSettings, this.canvasParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new ViewSettings(parsedSettings);
  }
}
